import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { HeroLayout } from '@primer/gatsby-theme-doctocat';
import Icons from '../src/components/icons';
export const _frontmatter = {
  "title": "Octicons"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = HeroLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Icons mdxType="Icons" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      